export const CONTACT_EMAIL = 'inquiries@researchsciencegroup.org'

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/mV9B7tTDawLjEXGEwbeKrq/189a436f-3ef5-43f2-8002-c3536a9060e5.png'

export const LOGO_ALT = 'Research Science Group — An Innovation Engine'

export const POSITIONING =
  'Research Science Group provides advanced software development services enabling developers, teams, and organizations to understand and take advantage of changing technology.'
